module.exports = __webpack_public_path__ + "static/media/name.e4c71c3d.svg";